module.exports = __webpack_public_path__ + "static/media/loxone-bg-device.84db0dff.png";